import { render, staticRenderFns } from "./QuestionPartsEditor.vue?vue&type=template&id=472362da&scoped=true&"
import script from "./QuestionPartsEditor.vue?vue&type=script&lang=js&"
export * from "./QuestionPartsEditor.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPartsEditor.vue?vue&type=style&index=0&id=472362da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472362da",
  null
  
)

export default component.exports